import React from 'react';
import { withTheme } from 'styled-components';

const MoreIcon = ({ width, height, theme }) => {
  return (
    <svg 
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={ theme.themeColors.controlBar.rightPanel.icons.searchIcon.color }
      xmlns="http://www.w3.org/2000/svg" 
      data-ignore-click-outside="sidebar"
    >
      <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
    </svg>
  );
};

export default withTheme(MoreIcon);